import React, { useLayoutEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Message } from '@cx/ui'

const ErrorMsg = ({ children }: { children: React.ReactNode }) => {
  const [searchParams] = useSearchParams()

  useLayoutEffect(() => {
    const errorMsg = searchParams.get('errorMsg')
    if (errorMsg) {
      Message.error(errorMsg)
    }
  }, [searchParams])

  return <>{children}</>
}

export default ErrorMsg
